import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";
import { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribeStatus, setSubscribeStatus] = useState<"idle" | "success" | "error">("idle");

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && email.includes("@")) {
      setSubscribeStatus("success");
      setEmail("");
      setTimeout(() => setSubscribeStatus("idle"), 3000);
    } else {
      setSubscribeStatus("error");
    }
  };

  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-3xl mt-16">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="font-heading text-2xl md:text-3xl font-bold mb-4">
              保持联系
            </h3>
            <p className="text-foreground-400 text-sm leading-relaxed">
              洞察日报致力于为读者提供深度、优质的内容。订阅我们的简报，获取最新资讯。
            </p>
          </div>

          <div>
            <h4 className="font-body text-base font-semibold mb-4">导航</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                >
                  首页
                </Link>
              </li>
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                >
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-body text-base font-semibold mb-4">关注我们</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="http://dlqlbdnn.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors flex items-center gap-2"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-instagram-line" />
                  </span>
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="http://dlqlbdnn.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors flex items-center gap-2"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-youtube-line" />
                  </span>
                  YouTube
                </a>
              </li>
              <li>
                <a
                  href="http://dlqlbdnn.cn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors flex items-center gap-2"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-facebook-line" />
                  </span>
                  Facebook
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-body text-base font-semibold mb-4">
              订阅简报
            </h4>
            <p className="text-sm text-foreground-400 mb-3">
              每周精选内容直达您的邮箱
            </p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <input
                type="email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setSubscribeStatus("idle");
                }}
                placeholder="您的邮箱"
                className="flex-1 bg-foreground-900 border border-foreground-700 rounded-md px-3 py-2 text-sm text-background-50 placeholder-foreground-500 focus:outline-none focus:border-primary-400"
              />
              <button
                type="submit"
                className="w-10 h-10 bg-background-50 rounded-full flex items-center justify-center hover:bg-background-100 transition-colors flex-shrink-0"
                aria-label="Subscribe"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-foreground-950" />
                </span>
              </button>
            </form>
            {subscribeStatus === "success" && (
              <p className="text-xs text-accent-400 mt-2">订阅成功！</p>
            )}
            {subscribeStatus === "error" && (
              <p className="text-xs text-primary-400 mt-2">请输入有效邮箱</p>
            )}
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              © 2026 洞察日报. All rights reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors">
                使用条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-400 transition-colors">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}